import classNames from 'classnames';
import React from 'react';
import { Loader } from '.';
import { Size } from '../../../constants/commonEnums';

interface LoaderWithWrapperProps extends React.PropsWithChildren {
  loading: boolean;
  fullPage?: boolean;
  size?: Size;
  loaderUrl?: string;
  loadingLabel?: string;
  className?: string;
}

const LoaderWithWrapper: React.FC<LoaderWithWrapperProps> = (props) => {
  const loaderOverlayClasses = classNames({
    [`loader-overlay`]: true,
    [`full-loader-overlay`]: props.fullPage,
  });

  const loaderWrapperClasses = classNames({
    ['loader-wrapper']: true,
    ['full-page-loader-wrapper']: props.fullPage,
  });

  return props.loading ? (
    <div className={loaderWrapperClasses}>
      <div className={`${loaderOverlayClasses} ${props.className}`}>
        <Loader
          loaderUrl={props.loaderUrl}
          loadingLabel={props.loadingLabel}
          size={props.size}
          className={`loader`}
        ></Loader>
        {props.children}
      </div>
    </div>
  ) : (
    <>{props.children}</>
  );
};

export { LoaderWithWrapper };
